<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i>Loading
        </div>

        <div v-else>
        <vue-headful :title="entry.person_name+' - '+entry.covid_form_name+' [Custom Form] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/custom-forms`">
                            <i class="fa fa-file-text"></i> Form Entries
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/custom-forms/entry/view/${entry.id}`">
                            {{ entry.covid_form_name }} -
                            <template v-if="entry.employee_id">
                                {{ entry.FirstName }} {{ entry.LastName }}
                            </template>
                            <template v-else>
                                {{ entry.person_name }}
                            </template>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-9 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Delete Form Entry:</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger"><strong>Warning:</strong> You are about to permanently delete this entry. This cannot be undone.</div>
                        </div>
                        <div class="card-footer">
                            <button v-on:click="deleteEntry()" :disabled="deleting" class="btn btn-danger">
                                <i class="fa fa-trash"></i> Delete Entry
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css">
    .signature-pad {
        width: 100%;
        height: 300px;
        border: 1px solid #ddd;
    }
</style>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                entry: {},
            }
        },

        methods: {

            getEntry: function() {
                //Get the data
                this.$http
                    .get('/custom-forms/entry/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.entry = response.data.entry;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            deleteEntry(){
                //Setup
                this.deleting = true;

                //Get the data
                this.$http
                    .delete('/custom-forms/entry/delete/' + this.id)
                    .then(response => {
                        //Alert the user
                        this.$toastr.success('Custom Entry Deleted');

                        //Sendit
                        this.$router.push('/custom-forms');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.deleting = false;
                    });
            },

        },
        mounted() {
            //Get the Safety Meeting
            this.getEntry();
        }
    }
</script>
